module.exports = __webpack_public_path__ + "img/erweima_wx_mini.c5b6250e.jpg";